import React, { useEffect, useState } from "react";
import { Alert, Button, Table } from "reactstrap";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import { Link, useHistory } from "react-router-dom";
import Loading from "../components/Loading";
import { readStores } from "../utils/stores";

export const StoresComponent = () => {
  const history = useHistory();
  const { getAccessTokenSilently } = useAuth0();
  const [stores, setStores] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    getAccessTokenSilently()
      .then(readStores)
      .then(setStores)
      .catch((e) => setError(e.message || "Could not load your stores"));
  }, [getAccessTokenSilently]);

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-1">
        <h1>Your stores</h1>
        <Button color="primary" onClick={() => history.push("/stores/new")}>
          <i className="fas fa-plus me-2"></i>Add a store
        </Button>
      </div>
      <p className="text-muted">The shops where your customers try products on with KuzFit.</p>

      {error && <Alert color="danger">{error}</Alert>}
      {!stores && !error && <Loading />}
      {stores && stores.length === 0 && (
        <div className="text-center py-5">
          <h5 className="text-muted">No stores yet</h5>
          <p className="text-muted">Add your first store to connect it to KuzFit.</p>
        </div>
      )}
      {stores && stores.length > 0 && (
        <Table hover responsive>
          <thead>
            <tr><th>Store</th><th>Website</th></tr>
          </thead>
          <tbody>
            {stores.map((store) => (
              <tr key={store.id}>
                <td><Link to={`/stores/${store.id}`}><strong>{store.name}</strong></Link></td>
                <td>{store.domain}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default withAuthenticationRequired(StoresComponent, { onRedirecting: () => <Loading /> });
